import React, { useContext, useEffect, useMemo, useState } from 'react';
import CardBox from '@/pages/dashboard/components/CardBox';
import PieChart from '@/pages/dashboard/components/Chart/components/PieChart';
import { pieFormatterFunc } from '@/pages/dashboard/components/Chart/_config/utils';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import { useLocal, useOption, useWeekDayArr } from '@/pages/dashboard/utils/customHook';
import { commonValueNoThousandFormatter, getWeekDayTitle, handleDownload } from '@/pages/dashboard/utils/utils';
import { getOptions } from '../../_config/utils';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { momentFormat } from '@/pages/dashboard/utils/_config/filtersTimeFormat';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import useTitleDes from '@/pages/dashboard/hooks/useTitleDes';
import { connect } from 'umi';
import TitleDes from '@/pages/dashboard/components/TitleDes';

function ActiveUsersDaysCo(props: any) {
  const { data: comdata, config: comConfig, explainInfo } = props || {};
  const contextObj = useContext(FilterContext);
  const { filterVal = {} } = contextObj || {};
  const { timeType, rangeTime } = filterVal || {};
  const isWeek = timeType === 'Week';
  const { type, title, titleCN, titleDes: titleDesConfig, defaultAvtive = 0, resKey = 'active_days', componentMetrics, isHaveSubTitle } = comConfig || {};
  const { data: originData, loading, errorMsg: error } = comdata?.weekData || {};
  const { locale, getLocalText, formatMessage, isEN } = useLocal(type === 'biweekly' ? 'engagement_active_degree_biweekly' : 'engagement_active_degree_weekly');

  const [data, setData] = useState({
    [resKey]: [],
    time_range: ''
  });
  const [iseye, setIseye] = useState(true);
  const weekDayArr = useWeekDayArr();
  const subTitleTime = isWeek ? getWeekDayTitle(data?.time_range, weekDayArr, '~') : momentFormat(rangeTime?.[1], 'YYYY-MM');

  const { option, pieLegend, pieData, comTitle } = useMemo(() => {
    const option = getOptions(
      {
        x: 'day',
        legend: data?.[resKey]?.map((item: any) => ({
          key: 'value',
          name: `${item.day  }days`,
          record: item,
        })),
      },
      [
        {
          key: 'day',
          name: 'Day',
          header: getLocalText('days_date'),
          render: (record: any) => record.day?.replace('day', ' day')
        },
        {
          key: 'value',
          name: componentMetrics?.enName,
          header: isEN ? componentMetrics?.enName : componentMetrics?.cnName,
          render: (record: any) => dataFormat({ value: record?.value, formatRule: 'thousandsInit'})
        },
      ],
      data?.[resKey],
    );
    const comTitle = isEN ? title : titleCN;
    const pieLegend: any = data?.[resKey]?.map?.((item: any) => item.day);
    const pieData: any = data?.[resKey]?.map?.((item: any) => ({
      name: item.day,
      value: item.value,
    }));
    return {
      option,
      pieLegend,
      pieData,
      comTitle
    };
  }, [data, comConfig, isEN]);

  useEffect(() => {
    if (!originData) return;

    const originDataArr = originData?.[resKey]?.filter((item: any) =>
      // 和后端核对过value和ratio不会一个为空另一个不为空
      resKey === 'active_user_activity' ? (item?.this_value !== '' && item?.this_change !== '') :   (item?.value !== '' && item?.ratio !== '')
    );

    setData(
      {
        [resKey]: originDataArr?.map?.((item: any) => ({
          ...item,
          day: getLocalText('activity_day', { day: item.day, unit: item.day > 1 ? 'days' : 'day' }),
          value: commonValueNoThousandFormatter(componentMetrics?.type, item.value, componentMetrics?.decimal)
        })),
        time_range: originData?.time_range
      }
    );
  }, [originData, locale]);


  const { isNodata } = useOption(option);

  const renderList = [
    {
      type: 'pieChart',
      svgType: 'pie-chart-icon',
      content: formatMessage({ id: 'common_pie_chart' }),
      component: <PieChart
        height={340}
        chartData={pieData}
        legendData={pieLegend}
        config={{ chartPercentDecimal: componentMetrics?.chartPercentDecimal }}
        formatterFunc={(params: any) => 
          pieFormatterFunc(
            params,
            { filterValue: filterVal, timeType: filterVal?.timeType },
            {
              ...componentMetrics,
              pieTitle: getLocalText(`activity_chart_title`, { day: params?.name }),
            }
          )}
      />
    },
    {
      type: 'sheet',
      svgType: 'sheet',
      content: formatMessage({ id: 'common_table' }),
      component: <MiniTable
        height={340}
        loading={false}
        tableOption={option?.table?.option}
        tableList={option?.table?.data}
      />
    },
  ];

  const titleDes = useTitleDes({
    titleDesConfig,
    explainInfo,
    isEN,
  });

  return (
    <>
      <CardBox
        className='register-table'
        height={340}
        bordered={false}
        titleCom={
          <>
            {comTitle}
            <TitleDes titleDes={titleDes} />
          </>
        }
        // <div className='register-table-time'>{momentFormat(formValue?.filterValue?.rangeTime?.[1], 'YYYY-MM')}</div>
        subTitleCom={isHaveSubTitle ? <div className='register-table-time'>{subTitleTime}</div> : ''}
        renderList={renderList}
        defaultAvtive={defaultAvtive}
        setCurrentDataType={(type: any) => {
          if (type === 'eyes') {
            setIseye(!iseye);
          }
        }}
        downloadClick={async () => {
          handleDownload(option?.table, comTitle, false);
        }}
        isLoading={loading}
        isError={!!error}
        isNodata={isNodata}
      />
    </>
  );
}

export default connect((state: any) => ({
  explainInfo: state.dashboard?.explainInfo,
}))(ActiveUsersDaysCo);
